import React, { useEffect, useRef, useState } from "react";
import "./verifyOtp.css";
import {
  getLoginPolicyandTwoFactorAuthState,
  getLoginUIConfig,
  sendForgotPasswordOtpAddress,
  verifyOtpFromServer,
} from "../../services/authenticationService";
import { useLocation, useNavigate } from "react-router-dom";
import LoginUiComponent from "../../components/loginUiComponent/loginUiComponent";
import { openPopup } from "../../stateManagement/actions/popupActions";
import PasswordReset from "../../components/forgotPassword/PasswordReset";
import { maskEmail, padFunction } from "../otpVerification/otpVerificationUtils";
import OTPVerification from "../otpVerification/OTPVerification";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { Loader } from "../../components/loader/Loader";
import { ChannelkartNetworkGet } from "../../services/networkService";


export default function VerifyOtp() {
  const [loader , setLoader] = useState<boolean>(true);
  const [loginUIConfig, setLoginUIConfig] = useState(null);
  const CUR_COMPONENT = "ValidateOtp"
  const { translate } = usePortalTranslation();
  const [isverifiedOtp, setisverifiedOtp] = useState(false);
  const [ContactAddress, setContactAddress] = useState("");
  const [contactAddressType, setcontactAddressType] = useState("sms");
  const location = useLocation();
  const navigate = useNavigate();

  const [otpLength, setOtpLength] = useState(6);

    useEffect(() => {
        (async () => {
            try {
                const response = await ChannelkartNetworkGet('/metadata/clientconfig?name=authentication_configuration');
                if (response?.status === 200 && response?.data?.features && response.data.features.length > 0 && response.data.features[0].domainValues) {
                    const configData = (response.data.features[0].domainValues as any[]).find((ele) => {
                        return ele.name === "otpLength";
                    });

                    if (configData?.value) {
                        setOtpLength(parseInt(configData?.value.toString()));
                    }
                }
            } catch (e) {}
        })();
    }, []);

  const twoFactorContactTypeRef = useRef<string|null>(null);
  interface LocationState {
    contactAddress: string;
    contactAddressType: string;
    twoFactorContactType:string;
    responseId?: string;
}
  useEffect(() => {
    const token = sessionStorage.getItem("TEMP_OTP_TOKKEN");
    const OtpAddress = location.state as LocationState;
    const isReload = sessionStorage.getItem("Is-FirstTime-Verify-Otp-Page");
    if (!token || isReload) {
      navigate(-1);
    }
    sessionStorage.setItem("Is-FirstTime-Verify-Otp-Page", "true");
    twoFactorContactTypeRef.current = OtpAddress.twoFactorContactType
    setcontactAddressType(OtpAddress.contactAddressType);
    setContactAddress(OtpAddress.contactAddress);
    return () => {
      sessionStorage.removeItem("Is-FirstTime-Verify-Otp-Page");
      sessionStorage.removeItem("TEMP_OTP_VERIFY_TOKKEN");
      sessionStorage.removeItem("TEMP_OTP_TOKKEN");
    };
  }, []);

  const verifyOtp = async (otp:string) => {
    if (otp && otp.length === otpLength) {
      const responseId = location.state.responseId || "";
      try {
        const response = await verifyOtpFromServer(
          otp,
          ContactAddress,
          contactAddressType,
          twoFactorContactTypeRef.current,
          "",
          responseId
        );

        if (response.data?.statusCode == 200 && response.data?.verified) {
          return {result :true , message:'Success'};
        } else {
          return {result :false , message:"Please enter the correct OTP"};
        }
      } catch (error) {
        return {result :false , message:"Please enter the correct OTP"};
      }
    } else {
      return {result : false , message:"Enter complete OTP"};
    }
  };

  const onSuccess = ()=>{
    setisverifiedOtp(true);
  }

  const onFailure = (message:string)=>{
    setisverifiedOtp(false);
    openPopup("Error", message);
  }

  const resendOtp = async () => {
    try{
    const response = await sendForgotPasswordOtpAddress(
      ContactAddress,
      contactAddressType,
      twoFactorContactTypeRef.current
    );
    if (response?.response?.statusCode === 200) {
      openPopup("Success", "OTP sent again");
    }
  }catch(error:any){
    openPopup("Error", error.message  ?? "RESEND OTP ERROR");
    console.error(error);
  }
  };

  useEffect(() => {
    const fetchLoginPolicy = async () => {
      try {
        setLoader(true);
        const { loginUIConfig } = await getLoginUIConfig();
        setLoginUIConfig(loginUIConfig);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error('Error fetching login policy:', error);
      }
    };
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    if (mediaQuery.matches) {
      setLoader(true);
      fetchLoginPolicy();
    }else{
      setLoader(true);
      setLoginUIConfig(null);
      setLoader(false);
    }
    const handleResize = async() => {
      if (mediaQuery.matches) {
        setLoader(true);
        await fetchLoginPolicy();
      }else{
        setLoader(true);
        setLoginUIConfig(null);
        setLoader(false);
      }
    };
    mediaQuery.addEventListener('change', handleResize);
    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);

  return (
    <>
    {
      loader ? <Loader /> :   <LoginUiComponent loginUIConfig={loginUIConfig}>
      {
        !isverifiedOtp ?
          <OTPVerification
          loginUIConfig={loginUIConfig}
            OtpVerficationHeader={
              <div style={loginUIConfig ? { color:"#ED1229" } : {}}  className="otp-label">
                 {translate(TranslationEnum.validate_otp,"OTP sent to your registered {phoneNumber}",{"phoneNumber":contactAddressType === "sms" ? "Phone Number" : "Email ID"})}
                {
                twoFactorContactTypeRef.current ? <></>:
                contactAddressType === "sms"
                  ? padFunction(ContactAddress)
                  : maskEmail(ContactAddress)
                }
              </div>
            }
            onFailure={onFailure}
            onSuccess={onSuccess}
            resendOtp={resendOtp}
            verifyOTP={verifyOtp}
            otpLength={otpLength}
          />
          :
          <PasswordReset />
      }
    </LoginUiComponent>
}
</>
  );
}
